/**
 * Strategia pubblicitaria effettiva di un VOD.
 * Se il contenuto ha la pubblicita' personalizzata attiva (info.ads_data), vince quella, come nel
 * legacy (AdsController); altrimenti resta la strategia generale del gruppo.
 */
export function resolveVodAdsCustomization(group, filesAdsData) {
    if (!filesAdsData) {
        return group;
    }
    return {
        vod_pre_roll_status: filesAdsData.pre_roll_active,
        vod_post_roll_status: filesAdsData.post_roll_active,
        vod_mid_roll_type: filesAdsData.mid_roll_active,
        vod_mid_roll_times: filesAdsData.mid_roll_video_times,
    };
}
